var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 95,
    viewBox: "0 0 89 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4053 1.01359C67.0859 1.47897 80.9448 16.8712 86.2899 34.846C91.2159 51.4111 85.2386 68.708 71.7203 79.4175C56.086 91.8033 34.8601 99.9222 18.4543 88.5866C1.04326 76.5564 -2.60866 52.8708 4.25501 32.8023C10.757 13.7913 28.3887 0.514915 48.4053 1.01359Z",
    fill: "url(#paint0_radial_18_5869)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_5869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5 47.5) rotate(46.5571) scale(63.2606 38.0245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080625"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse);
export default __webpack_public_path__ + "static/media/eclipse.ebe3805d021fe60fe3115bf1e3245d42.svg";
export { ForwardRef as ReactComponent };